import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
const BASE_URL = baseUrl +'/system' 

export default {
	/**
	 * 获取省
  	 * GET /system/getProvinceList
	**/
	getProvinceList(){
		return request({
			url: BASE_URL+'/getProvinceList',
			method:'get'
		})
	},

	/**
	 * 获取市区列表
  	 * GET /system/getCityList
	**/
	getCityList(params){
		return request({
			url: BASE_URL+'/getCityList',
			method:'get',
			params
		})
	},

	/**
	 * 获取区县
  	 * GET /system/getAreaList
	**/
	getAreaList(params){
		return request({
			url: BASE_URL+'/getAreaList',
			method:'get',
			params
		})
	},

	/**
	 * 上传接口
  	 * POST /system/uploadFile
  	 * type 1用户图片 2屏幕资源 3路灯excel
  	 * file
	**/
    uploadFile(data) {
		return request({
		url: BASE_URL+'/uploadFile',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 首页数据展示
	**/
	systemIndex() {
		return request({
	    url: baseUrl + '/system/index',
	    method: 'GET'
	  })
	}
}